import { StyleSheet } from 'react-native';
export var getDurationPickerWidgetStyles = () => {
  return StyleSheet.create({
    carouselView: {
      height: 310,
      width: '100%',
      flexDirection: 'row',
      marginVertical: 30,
      justifyContent: 'center',
      alignSelf: 'center',
      marginLeft: -20
    }
  });
};